import React from 'react';
import { weakKey } from '../../../utilities/weakKey';
import { ContactUsPageTypes } from '..';
import { ClickableContactDiv } from './ClickableContactDetails';
import { IconsHelper } from '../helpers/IconsHelper';
import { ClickableText } from '../../../components/clickableText/ClickableText';
import { useVariant } from '../hooks/VariantContext';

export const ReachUs = ({
  data,
  title,
  linkType,
  allIconsColor,
  addressDetails,
}: ContactUsPageTypes.TReachUsComponentTypes) => {
  const variant = useVariant();

  const getFlex = () => {
    return variant === 'newContactUsDarkTheme' ? 'is-flex' : '';
  };

  const getMargin = () => {
    return variant === 'newContactUsDarkTheme' ? '' : 'ml-3';
  };

  return (
    <>
      {data.map((contactData: ContactUsPageTypes.TReachUsTypes) => {
        const { data = '', icon, link } = contactData;
        return (
          <React.Fragment key={weakKey(contactData)}>
            {link && icon && linkType && (
              <ClickableContactDiv
                text={data}
                type={linkType}
                url={link}
                addressDetails={addressDetails}
              >
                <div className={`${getFlex()} listContentContainer`}>
                  <IconsHelper
                    allIconsColor={allIconsColor}
                    iconsConfig={icon}
                  />
                  {title && <h5 className="listTitle ml-3 pb-3">{title}</h5>}
                </div>
                <div className={`${getMargin()} `}>
                  <ClickableText
                    type={linkType}
                    text={data}
                    url={link}
                    addressDetails={addressDetails}
                  />
                </div>
              </ClickableContactDiv>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};
